module.exports = __webpack_public_path__ + "img/remove.4182aec1.svg";